/*
  The Front / Back panel, laid out as the portal's GradingImages: two slots side by side,
  each captioned, a dashed placeholder where a face has no image.

  These are the CATALOG's art for the card, not photographs of this slab — the graded
  card's own `files` come back empty on the public API — so the panel says so (D6), and a
  customer does not take a stock scan for a picture of their own copy.

  On a desktop the slots take their height from the viewport (D2): the report is meant to
  fit one screen, and the images are the one part that can give up height without losing
  information. The clamp keeps them legible on a short laptop and stops them growing past a
  natural size on a tall monitor; the max-height is the cap for a browser without dvh, which
  drops the clamp. Below lg the page scrolls, so they size by width instead.
*/

type Face = { label: string; src: string | null };

/* Card proportions (63×88mm, near enough the portal's 9 / 12.5). */
const SLOT = 'aspect-[63/88] rounded-[10px] lg:h-[clamp(150px,calc(100dvh-37rem),420px)] lg:max-h-[420px] lg:w-auto';

function CardFaces({ cardName, faces }: { cardName: string; faces: Face[] }) {
  return (
    <div className="flex flex-col items-center">
      <div className="flex w-full justify-center gap-3 sm:gap-5">
        {faces.map((face) => (
          <figure key={face.label} className="m-0 flex w-[48.5%] max-w-[260px] flex-col items-center lg:w-auto lg:max-w-none">
            {face.src ? (
              <img
                src={face.src}
                alt={`${cardName || 'Card'}, ${face.label.toLowerCase()}`}
                className={`${SLOT} w-full bg-pcg-surfaceDeep object-contain`}
              />
            ) : (
              <div
                className={`${SLOT} flex w-full flex-col items-center justify-center border border-dashed border-pcg-borderStrong bg-pcg-raised px-2 text-center text-sm font-semibold text-pcg-textMuted`}
              >
                No image
              </div>
            )}
            <figcaption className="mt-1.5 text-center text-sm font-bold text-pcg-text">
              {face.label}
            </figcaption>
          </figure>
        ))}
      </div>
      {faces.some((face) => face.src) && (
        <p className="mb-0 mt-1 text-center text-xs text-pcg-textDim">
          Catalog image, not a photo of this slab.
        </p>
      )}
    </div>
  );
}

export default CardFaces;
